<template>
  <div id="transfer-event-page" class="page-container">
    <!-- Stunning Header Card -->
    <v-card elevation="20" class="header-card mb-4 overflow-hidden">
      <div class="header-gradient">
        <div class="header-content pa-5">
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <div class="header-icon-box mr-4">
                  <v-icon size="48" color="white">mdi-transfer-right</v-icon>
                </div>
                <div>
                  <h1
                    class="text-h4 font-weight-bold white--text mb-1 header-title"
                  >
                    {{ PageTitle }}
                  </h1>
                  <p class="text-subtitle-1 white--text mb-0 header-subtitle">
                    <v-icon size="16" color="white" class="mr-1"
                      >mdi-information-outline</v-icon
                    >
                    Transfer event participants to a different event plan
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <div class="d-flex justify-end flex-wrap gap-2">
                <!-- Refresh Button -->
                <v-btn
                  color="rgba(255,255,255,0.2)"
                  elevation="0"
                  rounded
                  large
                  class="action-btn white--text"
                >
                  <v-icon left>mdi-refresh</v-icon>
                  Refresh
                </v-btn>

                <!-- Close Button -->
                <v-btn
                  @click="closePrompt"
                  color="rgba(255,255,255,0.2)"
                  elevation="0"
                  rounded
                  large
                  class="action-btn white--text"
                >
                  <v-icon left>mdi-close</v-icon>
                  Close
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <!-- Loading Indicator -->
    <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <!-- Main Form Card -->
    <v-card elevation="12" class="form-card mb-4" v-if="!LoadingFlag">
      <v-card-text class="pa-5">
        <v-container>
          <!-- NatCon Flag True - Search and Details View -->
          <div v-if="recordData.NatconFlag">
            <v-form ref="form" v-model="valid1" lazy-validation>
              <!-- Form Header -->
              <div class="form-header mb-5">
                <v-icon color="primary" size="32" class="mr-2"
                  >mdi-information-variant</v-icon
                >
                <span class="text-h5 font-weight-bold primary--text"
                  >Event & Participant Information</span
                >
              </div>

              <!-- Event and Plan Details -->
              <v-row wrap>
                <v-col cols="12" md="6">
                  <v-card class="detail-card pa-4" outlined elevated>
                    <v-card-title class="pa-0 mb-3 d-flex align-center">
                      <v-icon color="primary" size="28" class="mr-2"
                        >mdi-calendar-month</v-icon
                      >
                      Event Details
                    </v-card-title>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <v-icon size="16" class="mr-1"
                              >mdi-calendar-check</v-icon
                            >Event Name
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 font-weight-bold">{{
                            recordData.EventName
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="my-2"></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <v-icon size="16" class="mr-1">mdi-calendar</v-icon
                            >Order Date
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 font-weight-bold">{{
                            recordData.OrdersDateTxt
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="my-2"></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <v-icon size="16" class="mr-1">mdi-book-open</v-icon
                            >Plan Name
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 font-weight-bold">{{
                            recordData.PlanName
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card class="detail-card pa-4" outlined elevated>
                    <v-card-title class="pa-0 mb-3 d-flex align-center">
                      <v-icon color="primary" size="28" class="mr-2"
                        >mdi-account-details</v-icon
                      >
                      Member Details
                    </v-card-title>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <v-icon size="16" class="mr-1">mdi-account</v-icon
                            >Member Name & ID
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 font-weight-bold"
                            >{{ recordData.ParticipantName }}
                            <v-chip
                              small
                              color="primary"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ recordData.ParticipantMembershipId }}
                            </v-chip>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="my-2"></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <v-icon size="16" class="mr-1"
                              >mdi-map-marker</v-icon
                            >Zone
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 font-weight-bold">{{
                            recordData.ZoneName
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="my-2"></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <v-icon size="16" class="mr-1"
                              >mdi-office-building</v-icon
                            >LO Name
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 font-weight-bold">{{
                            recordData.LomName
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Form Section Header -->
              <div class="form-header mt-6 mb-4">
                <v-icon color="primary" size="32" class="mr-2"
                  >mdi-account-search</v-icon
                >
                <span class="text-h5 font-weight-bold primary--text"
                  >Enter Membership ID</span
                >
              </div>

              <v-row wrap>
                <v-col cols="12" md="12">
                  <p>
                    <span class="text-danger">*</span> indicates required field
                  </p>
                </v-col>

                <!-- Membership Search Section -->
                <v-col cols="12" md="6">
                  <div class="field-label">
                    <v-icon color="primary" size="18" class="mr-1"
                      >mdi-card-account-details</v-icon
                    >
                    <span class="text-danger">*</span> Membership ID
                  </div>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                        v-model="MembershipId"
                        placeholder="Enter Membership ID"
                        dense
                        outlined
                        clearable
                        class="custom-input"
                        prepend-inner-icon="mdi-identifier"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" align="center">
                      <v-btn
                        @click.prevent="getMemberRecords"
                        :loading="SearchFlag"
                        color="primary"
                        icon
                        dark
                        class="mt-1 search-icon-btn"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- No Results Message -->
              <v-row wrap v-if="SearchAttempted && !Member" class="mt-4">
                <v-col cols="12">
                  <v-alert type="info" dense outlined icon="mdi-information">
                    No records found for the selected membership ID.
                  </v-alert>
                </v-col>
              </v-row>

              <!-- Member Details Display -->
              <v-card
                v-if="Member && Object.keys(Member).length"
                elevation="8"
                class="member-preview-card mt-5"
              >
                <div class="member-card-header pa-4">
                  <v-icon color="white" size="28" class="mr-2"
                    >mdi-account-circle</v-icon
                  >
                  <span class="text-h5 font-weight-bold white--text"
                    >Member Details</span
                  >
                </div>

                <v-card-text class="pa-5">
                  <v-row>
                    <!-- Photo Section -->
                    <v-col
                      cols="12"
                      md="3"
                      class="d-flex justify-center align-center"
                    >
                      <div class="avatar-wrapper">
                        <v-avatar size="140" class="member-avatar">
                          <img
                            v-if="Member.PhotoFlag"
                            :src="Member.Photo"
                            alt="Profile"
                          />
                          <img v-else :src="Member.Photo" alt="Profile" />
                        </v-avatar>
                        <div
                          class="avatar-badge"
                          v-if="Member.AadhaarVerifiedFlag"
                        >
                          <v-icon color="white" size="20"
                            >mdi-check-decagram</v-icon
                          >
                        </div>
                      </div>
                    </v-col>

                    <!-- Member Info -->
                    <v-col cols="12" md="9">
                      <div class="member-info-section">
                        <h2 class="text-h4 font-weight-bold primary--text mb-4">
                          {{ Member.MemberName }}
                        </h2>

                        <v-row>
                          <v-col cols="12" md="6">
                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-identifier</v-icon
                              >
                              <div>
                                <div class="info-label">Membership ID</div>
                                <div class="info-value">
                                  {{ Member.MembershipId }}
                                </div>
                              </div>
                            </div>

                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-briefcase</v-icon
                              >
                              <div>
                                <div class="info-label">Designation</div>
                                <div class="info-value">
                                  {{ Member.Designation || "N/A" }}
                                </div>
                              </div>
                            </div>

                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-email</v-icon
                              >
                              <div>
                                <div class="info-label">Email</div>
                                <div class="info-value">
                                  {{ Member.EmailId || "N/A" }}
                                </div>
                              </div>
                            </div>

                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-phone</v-icon
                              >
                              <div>
                                <div class="info-label">Mobile No</div>
                                <div class="info-value">
                                  {{ Member.MobileNo || "N/A" }}
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <v-col cols="12" md="6">
                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-card-account-details-outline</v-icon
                              >
                              <div>
                                <div class="info-label">Aadhaar Status</div>
                                <v-chip
                                  :color="Member.AadhaarTextColor"
                                  dark
                                  small
                                  class="mt-1"
                                >
                                  <v-icon small left>mdi-check-circle</v-icon>
                                  {{ Member.AadhaarVerifiedTxt }}
                                </v-chip>
                              </div>
                            </div>

                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-map-marker</v-icon
                              >
                              <div>
                                <div class="info-label">Zone</div>
                                <div class="info-value">
                                  {{ Member.ZoneName || "N/A" }}
                                </div>
                              </div>
                            </div>

                            <div class="info-card mb-3">
                              <v-icon color="primary" class="mr-2"
                                >mdi-office-building</v-icon
                              >
                              <div>
                                <div class="info-label">LO</div>
                                <div class="info-value">
                                  {{ Member.LomName || "N/A" }}
                                </div>
                              </div>
                            </div>

                            <div
                              class="info-card mb-3"
                              v-if="Member.MemberDueCount > 0"
                            >
                              <v-icon color="primary" class="mr-2"
                                >mdi-currency-inr</v-icon
                              >
                              <div>
                                <div class="info-label">Due Count</div>
                                <v-chip
                                  color="red darken-2"
                                  dark
                                  small
                                  class="mt-1"
                                >
                                  <v-icon small left>mdi-alert-circle</v-icon>
                                  {{ Member.MemberDueCount }}
                                </v-chip>
                              </div>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row v-if="Member.AddressTxt" class="mt-2">
                          <v-col cols="12">
                            <div class="info-card">
                              <v-icon color="primary" class="mr-2"
                                >mdi-home-map-marker</v-icon
                              >
                              <div>
                                <div class="info-label">Address</div>
                                <div class="info-value">
                                  {{ Member.AddressTxt }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text class="pa-5 pt-0" v-if="Member.MissingSteps">
                  <v-alert type="warning" dense outlined icon="mdi-alert">
                    <strong>Missing Steps:</strong> {{ Member.MissingSteps }}
                  </v-alert>
                </v-card-text>
              </v-card>

              <v-row wrap class="mt-6">
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    :disabled="NatconFlag && !MemberFlag"
                    @click.prevent="submitForm"
                    :loading="SubmitFlag"
                    elevation="8"
                    x-large
                    rounded
                    color="success"
                    class="px-10 submit-btn white--text"
                  >
                    <v-icon left size="24">mdi-check-circle</v-icon>
                    SUBMIT
                  </v-btn>
                  <v-btn
                    @click="closePrompt"
                    elevation="8"
                    x-large
                    rounded
                    color="error"
                    class="px-10 ml-3 clear-btn white--text"
                  >
                    <v-icon left size="24">mdi-close-circle</v-icon>
                    CLOSE
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </div>

          <!-- NatCon Flag False - Original Form -->
          <div v-else>
            <v-form ref="form" v-model="valid1" lazy-validation>
              <!-- Form Header -->
              <div class="form-header mb-5">
                <v-icon color="primary" size="32" class="mr-2"
                  >mdi-form-select</v-icon
                >
                <span class="text-h5 font-weight-bold primary--text"
                  >Select Event & Plan</span
                >
              </div>

              <div class="form-section mb-4">
                <v-row wrap>
                  <v-col cols="12" md="12">
                    <p>
                      <span class="text-danger">*</span> indicates required
                      field
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <div class="field-label">
                      <v-icon color="primary" size="18" class="mr-1"
                        >mdi-calendar-month</v-icon
                      >
                      <span class="text-danger">*</span> Event Name
                    </div>
                    <v-autocomplete
                      @change="getPlanOptions"
                      :reduce="(option) => option.value"
                      :items="EventIdOptions"
                      :rules="EventIdRules"
                      v-model="EventId"
                      dense
                      clearable
                      required
                      outlined
                      class="custom-input"
                      placeholder="Select Event Name"
                      prepend-inner-icon="mdi-calendar-check"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <div class="field-label">
                      <v-icon color="primary" size="18" class="mr-1"
                        >mdi-file-document</v-icon
                      >
                      <span class="text-danger">*</span> Plan Name
                    </div>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :items="PlanIdOptions"
                      :rules="PlanIdRules"
                      v-model="PlanId"
                      dense
                      clearable
                      required
                      outlined
                      class="custom-input"
                      placeholder="Select Plan Name"
                      prepend-inner-icon="mdi-book-open-variant"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </div>

              <v-row wrap class="mt-6">
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    @click.prevent="submitForm"
                    :loading="SubmitFlag"
                    elevation="8"
                    x-large
                    rounded
                    color="success"
                    class="px-10 submit-btn white--text"
                  >
                    <v-icon left size="24">mdi-check-circle</v-icon>
                    SUBMIT
                  </v-btn>
                  <v-btn
                    @click="closePrompt"
                    elevation="8"
                    x-large
                    rounded
                    color="error"
                    class="px-10 ml-3 clear-btn white--text"
                  >
                    <v-icon left size="24">mdi-close-circle</v-icon>
                    CLOSE
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
  
  <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
export default {
  mixins: [common],
  props: {
    transferEventPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: false,

      LoadingFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      SearchFlag: false,
      SearchAttempted: false,

      EventType: "",

      EventIdRules: [(v) => !!v || "Event is required"],
      EventId: "",
      EventIdOptions: [],

      PlanIdRules: [(v) => !!v || "Plan Id is required"],
      PlanId: "",
      PlanIdOptions: [],

      PageInfo: {},
      PageTitle: "Transfer Event",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      MembershipId: "",

      // Member search results
      Member: null,
      MemberFlag: false,
      NatconFlag: false,
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var server_url = companyConfig.apiURL;
        console.log("server_url = " + server_url);
        var SampleFilePath =
          server_url + "assets/sample/jcom_table_member_upload_sample.xlsx";
        console.log("SampleFilePath = " + SampleFilePath);
        this.SampleFilePath = SampleFilePath;
      }
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var NatconFlag = this.recordData.NatconFlag;
      console.log({ NatconFlag });
      this.NatconFlag = NatconFlag;
      // this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jcom_members_upload",
        Action: "create",
      };
      // this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
      this.LoadingFlag = false;
    },
    pageData() {
      console.log("pageData called");
      var data = this.recordData;
      console.log({ data });
      this.getEventOptions();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidetransferEventPrompt", this.ResultFlag);
    },
    getMemberRecords() {
      console.log("getMemberRecords called");

      var MembershipId = this.MembershipId;
      console.log({ MembershipId });

      this.MemberFlag = false;
      this.SearchFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nominate-member-subscription/info";
      var upload = {
        UserInterface: 2,
        Membership: MembershipId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );
      console.log("recordData:", this.recordData);

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SearchFlag = false;
          thisIns.SearchAttempted = true;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.MemberFlag = true;
            thisIns.Member = records;
            thisIns.SearchResults = [records];
            thisIns.toast("success", output);
          } else {
            thisIns.Member = null;
            thisIns.SearchResults = [];
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.OverlayLoadingFlag = false;
          thisIns.SearchFlag = false;
        });
    },
    getEventOptions() {
      console.log("getEventOptions called");
      var EventType = this.recordData.EventTypeId;
      var selectbox1_source = "EventId";
      var selectbox1_destination = "EventIdOptions";
      var selectbox1_url = "api/jci-program/options";

      var selectbox1_conditions_array = {
        UserInterface: 3,
        EventType: EventType,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getPlanOptions() {
      console.log("getPlanOptions called");
      var selectbox1_source = "PlanId";
      var selectbox1_destination = "PlanIdOptions";
      var selectbox1_url = "api/jci-program/plan/options";

      var selectbox1_conditions_array = {
        UserInterface: 1,
        Event: this.EventId,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form.validate();
      console.log("validate1=" + validate1);

      // validate1 = false;
      var PlanId = this.PlanId != "" ? this.PlanId : "";
      console.log({ PlanId });

      var EventId = this.EventId != "" ? this.EventId : null;
      console.log({ EventId });

      var OrdersId = this.recordData.OrdersId;
      console.log({ OrdersId });

      var UserInterface = this.NatconFlag ? 2 : 1;
      console.log({ UserInterface });
      console.log("NatconFlag value:", this.NatconFlag);

      if (validate1) {
        var upload = {
          UserInterface: UserInterface,
          Plan: PlanId,
          Orders: OrdersId,
          LO: this.recordData.LomId,
          Zone: this.recordData.ZoneId,
        };

        // Only add Member if NatconFlag is true (member search was performed)
        if (this.NatconFlag && this.Member) {
          upload.Member = this.Member.MemberId;
        }

        console.log({ upload });

        this.progessStart = 1;
        this.SubmitFlag = true;
        this.ResultFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/order/transfer-event";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;

            flag = response.data.flag;
            output = response.data.output;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.progessStart = 0;
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
  <style lang="scss" scoped>
.page-container {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* ============================================
   HEADER CARD
   ============================================ */
.header-card {
  border-radius: 20px !important;
  overflow: hidden;
  animation: slideDown 0.6s ease-out;
}

.header-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: rotate 20s linear infinite;
  }
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: float 3s ease-in-out infinite;
}

.header-title {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 0.8s ease-out;
}

.header-subtitle {
  opacity: 0.95;
  animation: fadeInUp 1s ease-out;
}

.action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 700;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
  }
}

/* ============================================
   FORM CARD
   ============================================ */
.form-card {
  border-radius: 16px !important;
  animation: fadeIn 0.8s ease-out;
}

.form-header {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 3px solid #667eea;
  margin-bottom: 24px;
}

.form-section {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.03) 0%,
    rgba(118, 75, 162, 0.03) 100%
  );
  border: 1px solid rgba(102, 126, 234, 0.1);
  border-radius: 12px;
  padding: 20px;
}

.detail-card {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.05) 0%,
    rgba(118, 75, 162, 0.05) 100%
  ) !important;
  border-left: 4px solid #667eea !important;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2) !important;
    transform: translateY(-2px);
  }
}

.field-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #004e92;
  margin-bottom: 8px;
  font-size: 14px;

  .text-danger {
    color: #ff6b6b;
    margin: 0 4px;
  }
}

.custom-input {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  ::v-deep &.v-input--is-focused .v-input__slot {
    border-color: #667eea !important;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
  }
}

.search-icon-btn {
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4) !important;
  }
}

/* ============================================
   MEMBER PREVIEW CARD
   ============================================ */
.member-preview-card {
  border-radius: 16px !important;
  overflow: hidden;
  animation: slideInUp 0.6s ease-out;
  border: 2px solid #667eea;
}

.member-card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
}

.member-avatar {
  border: 4px solid #667eea;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4);
  }
}

.avatar-badge {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: linear-gradient(135deg, #1db954 0%, #17a347 100%);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.member-info-section {
  animation: fadeInRight 0.8s ease-out;
}

.info-card {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.05) 0%,
    rgba(118, 75, 162, 0.05) 100%
  );
  border-radius: 10px;
  border-left: 3px solid #667eea;
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(5px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
  }
}

.info-label {
  font-size: 12px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* ============================================
   ACTION BUTTONS
   ============================================ */
.submit-btn {
  font-weight: 700;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(29, 185, 84, 0.4) !important;
  }
}

.clear-btn {
  font-weight: 700;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(244, 67, 54, 0.4) !important;
  }
}

.gap-2 {
  gap: 8px;
}

.text-danger {
  color: #d32f2f;
}

.text-h6 {
  font-weight: 500;
}

/* ============================================
   ANIMATIONS
   ============================================ */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 960px) {
  .header-content {
    text-align: center;

    .d-flex {
      flex-direction: column;
      align-items: center !important;
    }

    .text-right {
      text-align: center !important;
    }
  }

  .action-btn {
    margin: 4px 0 !important;
  }

  .member-info-section {
    text-align: center;
  }
}
</style>